import { render, staticRenderFns } from "./WhatsappIntegration.vue?vue&type=template&id=3dec323a"
import script from "./WhatsappIntegration.vue?vue&type=script&lang=js"
export * from "./WhatsappIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports